module.exports = __webpack_public_path__ + "images/8.4ac55be3.png";